/* © 2026 MINOTI Sp. z o.o. Wszelkie prawa zastrzeżone. Licencja: MINOTI Sp. z o.o. Autor: Adam Kulesza (8442055806). */
/*
  MINOTI 17.10.2026 — zmiana rozmiaru w linii koszyka (strona koszyka i szuflada).
  HTML: snippets/minoti-cart-size-swap.liquid (<select data-mn-size-swap>).

  Kolejność jest celowa: najpierw dodajemy nowy rozmiar (/cart/add.js, ta sama
  ilość, te same właściwości linii), a starą linię zerujemy (/cart/change.js)
  dopiero, gdy dodanie się udało. Po błędzie wynik może być niejednoznaczny:
  wymagamy odświeżenia koszyka przed kolejną próbą zmiany rozmiaru.

  Nasłuch na document w fazie przechwytywania + stopPropagation: zmiana listy
  nie dociera do formularza koszyka ani do elementów motywu, które słuchają
  'change' (pole ilości), więc nic nie wysyła formularza przy okazji.
*/
(function () {
  'use strict';
  if (window.mnSizeSwapBound) return;
  window.mnSizeSwapBound = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var swapBusy = false;

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          var err = new Error((data && (data.description || data.message)) || 'cart error');
          throw err;
        });
      }
      return res.json();
    });
  }

  function showError(select, text) {
    var box = select.closest('.mn-size-swap');
    var out = box && box.querySelector('.mn-size-swap__error');
    if (!out) return;
    out.textContent = text;
    out.hidden = false;
  }

  function refresh(select) {
    var inDrawer = !!select.closest('cart-drawer, #cart-drawer');
    var onCartPage = !!document.querySelector('.mnk') && !inDrawer;
    var path = window.location.pathname;
    if (path.slice(-1) === '/') path = path.slice(0, -1);
    if (onCartPage || path.slice(-5) === '/cart') {
      window.location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
  }

  function swap(select) {
    if (swapBusy) { select.value = select.getAttribute('data-current'); return; }
    var current = select.getAttribute('data-current');
    var next = select.value;
    if (!next || next === current) return;

    var qty = parseInt(select.getAttribute('data-qty'), 10) || 1;
    var key = select.getAttribute('data-line-key');
    var item = { id: Number(next), quantity: qty };

    try {
      var props = JSON.parse(select.getAttribute('data-props') || '{}');
      if (props && typeof props === 'object' && Object.keys(props).length) item.properties = props;
    } catch (e) {}

    var plan = select.getAttribute('data-selling-plan');
    if (plan) item.selling_plan = Number(plan);

    var error = select.closest('.mn-size-swap');
    error = error && error.querySelector('.mn-size-swap__error');
    if (error) error.hidden = true;

    swapBusy = true;
    var controls = Array.prototype.map.call(document.querySelectorAll('select[data-mn-size-swap]'), function (control) {
      var previous = control.disabled;
      control.disabled = true;
      return {control: control, disabled: previous};
    });
    function release() {
      swapBusy = false;
      controls.forEach(function (entry) { entry.control.disabled = entry.disabled; });
      select.removeAttribute('aria-busy');
    }
    function recover() {
      if (!select.isConnected) { window.location.reload(); return; }
      select.removeAttribute('aria-busy');
      var config = {};
      try { config = JSON.parse(document.getElementById('mn-ux2710-config').textContent); } catch (e) {}
      showError(select, config.cartError || select.getAttribute('data-error') || '');
      var box = select.closest('.mn-size-swap');
      var out = box && box.querySelector('.mn-size-swap__error');
      if (!out) { window.location.reload(); return; }
      out.setAttribute('role', 'alert');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'mn-size-swap__recover';
      button.textContent = config.cartRefresh || 'Refresh basket';
      button.addEventListener('click', function () { window.location.reload(); });
      out.appendChild(button);
    }
    function finish() {
      var observer = new MutationObserver(function () {
        if (!select.isConnected) { observer.disconnect(); clearTimeout(timer); release(); }
      });
      observer.observe(document.body, {childList: true, subtree: true});
      var timer = setTimeout(function () { observer.disconnect(); if (select.isConnected) recover(); else release(); }, 8000);
      refresh(select);
    }
    select.disabled = true;
    select.setAttribute('aria-busy', 'true');

    post('cart/add.js', { items: [item] })
      .then(function () {
        /* Nowy rozmiar jest w koszyku, dopiero teraz usuwamy stary. */
        return post('cart/change.js', { id: key, quantity: 0 }).then(
          function () { finish(); },
          function () { recover(); }
        );
      })
      .catch(function () {
        select.value = current;
        recover();
      });
  }

  document.addEventListener(
    'change',
    function (event) {
      var select = event.target;
      if (!select || !select.matches || !select.matches('select[data-mn-size-swap]')) return;
      event.stopPropagation();
      swap(select);
    },
    true
  );
})();

